import PrivateRoute from '@web/components/PrivateRoute';
import Timesheets from '@web/containers/Timesheets';

export function Component() {
  return (
    <PrivateRoute>
      <Timesheets />
    </PrivateRoute>
  );
}

Component.displayName = 'StaffTimesheets';
